package music.jammers.client.shared.profile.domain

import music.jammers.client.shared.event.domain.model.ValidationError
import music.jammers.client.shared.profile.presentation.ui.ProfileFieldValidator
import music.jammers.shared.user.domain.model.UserProfileUpdateData

class ValidateProfileUseCase(
    private val profileFieldValidator: ProfileFieldValidator,
) {

    fun invoke(updateData: UserProfileUpdateData): List<ValidationError> {
        val result = mutableListOf<ValidationError?>()

        result.add(profileFieldValidator.validate(NAME, updateData.userName))
        result.add(profileFieldValidator.validate(TELEGRAM, updateData.telegram))
        result.add(profileFieldValidator.validate(CITY, updateData.city))

        return result.filterNotNull()
    }

    companion object {

        const val NAME = "name"
        const val TELEGRAM = "telegram"
        const val CITY = "city"
    }
}